<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <ng-container *ngFor="let documentControl of documentsControl.controls; let i = index">
    <div class="file-drop mb-3" [formGroup]="documentControl">
      <uni-file-input
        accept="{{ currentAcceptedFormat }}"
        [reference]="documentControl.value.name"
        [placeHolder]="documentControl.value.name"
        [dropZoneLabel]="documentControl.value.name"
        formControlName="file"
        [isFiduciary]="true"
        [isFiduciaryRequest]="true"
        [showFileDetails]="true"
        [FileNameToName]="fileNameToName"
        [FileNameToExtension]="fileNameToExtension"
        [GetFileSizeMegaBytes]="getFileSizeMegaBytes"
        [OpenUploadDocumentsModal]="openUploadDocumentsModal.bind(this)"
        [SetCurrentFilesListEvent]="setCurrentFilesListEvent.bind(this)"
        [SetcurrentFilesUploadAllEvent]="setcurrentFilesUploadAllEvent.bind(this)"
        [requestFiles]="filesList.concat(currentFilesUpload)"
        [_firstFile]="_firstFile"
      ></uni-file-input>
    </div>
  </ng-container>

  <div class="text-right pt-3">
    <button [disabled]="form.invalid || !isLessThan25Mb || invalidRequestFiles" type="submit" uni-button variant="primary">
      Crear Solicitud
    </button>
  </div>
</form>
